
const testimonials = [
  {
    quote: 'New Generation Welding handled our structural steel work on a tight deadline. Professional crew, clean welds, zero punch-list items. They\'re our go-to welding sub now.',
    name: 'Mike R.',
    role: 'General Contractor',
    rating: 5,
  },
  {
    quote: 'Called them for an emergency equipment repair on a Saturday. They had a mobile welder on-site within two hours. Saved us from a costly project delay.',
    name: 'Carlos D.',
    role: 'Site Superintendent',
    rating: 5,
  },
  {
    quote: 'Their custom fabrication work is top-notch. We\'ve used them for gates, handrails, and structural steel — always on time, always quality work.',
    name: 'James T.',
    role: 'Property Developer',
    rating: 5,
  },
];

export default function Testimonials() {
  return (
    <section className="py-24 bg-[#1A1A1A]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-3 mb-4">
            <div className="w-10 h-0.5 bg-[#E8740C]"></div>
            <span className="text-[#E8740C] text-xs font-semibold tracking-[0.2em] font-heading uppercase">Contractor Testimonials</span>
            <div className="w-10 h-0.5 bg-[#E8740C]"></div>
          </div>
          <h2 className="font-heading text-4xl md:text-5xl font-bold text-white leading-tight">
            TRUSTED BY <span className="text-[#E8740C]">CONTRACTORS</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {testimonials.map((t) => (
            <article key={t.name} className="bg-[#242424] border border-white/5 rounded-lg p-7">
              <div className="flex gap-1 mb-5">
                {Array.from({ length: t.rating }).map((_, i) => (
                  <div key={i} className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-star-fill text-[#E8740C] text-sm"></i>
                  </div>
                ))}
              </div>
              <p className="text-white/70 text-sm leading-relaxed mb-6 font-body italic">
                &ldquo;{t.quote}&rdquo;
              </p>
              <div className="border-t border-white/10 pt-5">
                <p className="text-white font-heading font-bold text-sm">{t.name}</p>
                <p className="text-[#E8740C] text-xs font-medium mt-0.5">{t.role}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
